import React from 'react';
import { Fab } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { motion } from 'framer-motion';

interface SideMenuTogglePropsMovil {
  isSideMenuOpen: boolean;
  toggleSideMenu: () => void;
}

const fabVariants = {
  initial: { x: 0 },
  activated: { x: 0 },
};

export const SideMenuToggleMovil: React.FC<SideMenuTogglePropsMovil> = ({ isSideMenuOpen, toggleSideMenu }) => {
  return (
    <motion.div

      style={{
        position: 'fixed', // Para que permanezca en su posición al hacer scroll
        top: '98%', // Centrado verticalmente
        left: '50%', // Centrado horizontalmente
        transform: 'translate(-50%, -50%)', // Ajuste preciso para centrar en ambos ejes
      }}
    >
      <Fab
        size="small"
        onClick={toggleSideMenu}
        sx={{
          bgcolor: 'white',
          borderTopLeftRadius: '-50%',
          borderBottomRightRadius: '0%',
          borderBottomLeftRadius: '0%',
          '&:hover': {
            bgcolor: 'grey.200',
          },
        }}
      >
        <KeyboardArrowUpIcon />
      </Fab>
    </motion.div>
  );
};
